function authPopups() {
    const classList = "hidden-popup container-login container-register container-forgot-password"

    $(document).on("click", '.cta-login', function() {
        $("#auth-popup-wrapper").show()
        $("#auth-popup-wrapper").find(".popup-wrapper--container").removeClass(classList)
        $("#auth-popup-wrapper").find(".popup-wrapper--container").addClass("container-login")
    })

    $(document).on("click", '.cta-register', function() {
        $("#auth-popup-wrapper").show()
        $("#auth-popup-wrapper").find(".popup-wrapper--container").removeClass(classList)
        $("#auth-popup-wrapper").find(".popup-wrapper--container").addClass("container-register")
    })

    $(document).on("click", '.cta-forgot-password', function() {
        $("#auth-popup-wrapper").show()
        $("#auth-popup-wrapper").find(".popup-wrapper--container").removeClass(classList)
        $("#auth-popup-wrapper").find(".popup-wrapper--container").addClass("container-forgot-password")
    })
}

$(document).ready( function() {
    authPopups()
})